import React, { useEffect, useState } from "react";
import PublicRoutes from "../containers/PublicRoutes";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getArticleList } from "../actions";
import { sortArticle } from "../utils";
import ContrastBtn from "./ContrastBtn";
import Footer from "./Footer";
import { EXCLUDED_IDS_FROM_MENU } from "../utils/config";

const FISHMARKET_LOGO = require("../assets/fishmarket.png");

const MainPageWithMenuScreen = ({ location }) => {
  const [showMenu, setShowMenu] = useState(false);
  const toggleShowMenu = () => setShowMenu(!showMenu);
  const dispatch = useDispatch();
  const {
    articles: { articleList },
    app: { appContrast, appFontSize },
  } = useSelector((state) => state);
  useEffect(() => {
    if (!articleList) dispatch(getArticleList());
  }, [articleList]);

  const renderUrl = (path, pathName, articleId = null) => {
    const urlMath = path.pathname
      ? path.article === location.article
      : path === location.pathname;

    const isParentUrl = articleList.find(
      (art) => art.parentId && art.parentId === articleId
    );

    if (isParentUrl)
      return (
        <li className="nav-item dropdown" key={`topMenu${pathName}`}>
          <Link
            className={`nav-link px-2 px-md-3 ${
              urlMath ? "fishmarket-green" : "fishmarket-blue"
            }`}
            to={path}
            title={pathName}
          >
            {pathName}
          </Link>

          <div
            className="dropdown-menu mt-0 pb-0 border-0"
            aria-labelledby="dropdownMenuLink"
          >
            {articleList
              .filter((art) => art.parentId && art.parentId === articleId)
              .map((art) => (
                <Link
                  key={art.id}
                  className={`nav-link dropdown-item expanded-menu-item ${
                    urlMath ? "fishmarket-green" : "fishmarket-blue"
                  }`}
                  to={{ pathname: "/article", article: art.id }}
                  title={art.title}
                >
                  {art.title}
                </Link>
              ))}
          </div>
        </li>
      );

    return (
      <li className="nav-item" key={`topMenu${pathName}`}>
        <Link
          className={`nav-link px-2 px-md-3 ${
            urlMath ? "fishmarket-green" : "fishmarket-blue"
          }`}
          to={path}
          title={pathName}
        >
          {pathName}
        </Link>
      </li>
    );
  };

  const renderMenu = () => {
    if (articleList === null) return null;

    return (
      <React.Fragment>
        <ContrastBtn />
        <nav className="navbar navbar-expand-lg navbar-light w-100 p-0">
          <button
            className="navbar-toggler border-0"
            type="button"
            data-toggle="collapse"
            onClick={toggleShowMenu}
            title="Strona główna"
          >
            <Link className="fishmarket-blue" to="/" title="Strona główna">
              Fishmarket Ustka
            </Link>
            <span className="navbar-toggler-icon ml-2"></span>
          </button>

          <div className={`collapse navbar-collapse ${showMenu && "show"}`}>
            <ul className="navbar-nav mr-auto">
              {renderUrl("/fishmarket", "Targ rybny")}
              {renderUrl("/fisherman-list", "Poznaj rybaków")}
              {renderUrl("/events", "Wydarzenia")}
              {articleList
                .filter((a) => !a.parentId)
                .filter(
                  (a) => a.id && EXCLUDED_IDS_FROM_MENU.indexOf(a.id) === -1
                )
                .sort(sortArticle)
                .map((a) =>
                  renderUrl(
                    { pathname: "/article", article: a.id },
                    a.title,
                    a.id
                  )
                )}
            </ul>
          </div>
        </nav>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <nav className="navbar sticky-top navbar-blue"></nav>
      <div className="container">
        <div className="row mb-2">
          <div className="col-md-2 col-sm-4 col-4">
            <Link to="/">
              <div>
                <img
                  alt="Fishmarket Ustka"
                  src={FISHMARKET_LOGO}
                  className="img-fluid fishmarket-logo"
                />
              </div>
            </Link>
          </div>
          <div className="col-md-10 col-sm-8 col-8 d-flex align-items-center flex-column justify-content-start justify-content-md-center">
            {renderMenu()}
          </div>
        </div>
      </div>
      <PublicRoutes />
      <Footer />
      {appContrast && (
        <link rel="stylesheet" type="text/css" href="css/a11y-contrast.css" />
      )}
      {appFontSize === 1 && (
        <link rel="stylesheet" type="text/css" href="css/font-size-big.css" />
      )}
      {appFontSize === 2 && (
        <link
          rel="stylesheet"
          type="text/css"
          href="css/font-size-bigger.css"
        />
      )}
    </React.Fragment>
  );
};

export default MainPageWithMenuScreen;



// WEBPACK FOOTER //
// ./src/screens/MainPageWithMenuScreen.js